import { gql } from 'apollo-boost';

const FRAGMENT_GLOBAL_SEARCH_STUDENT = gql`
  fragment FragmentGlobalSearchStudent on GlobalSearchStudent {
    fullName
    gender
    contactEmail
    studentId
    studentExternalId
    emailVerified
    profilePhotoFileUuid
    isRebooker
    originId
    customFieldValues {
      id
      labelName
      value
    }
  }
`;

const FRAGMENT_GLOBAL_SEARCH_CONTACT = gql`
  fragment FragmentGlobalSearchContact on GlobalSearchContact {
    fullName
    relationship
    contactEmail
    studentId
    bookingId
    propertyId
  }
`;

const FRAGMENT_GLOBAL_SEARCH_BOOKING = gql`
  fragment FragmentGlobalSearchBooking on GlobalSearchBooking {
    studentFullName
    studentMobilePhone
    studentEmail
    bookingCategory
    tenancyOptionName
    bedName
    bookingStatus
    bookingId
    tenancyStartDate
    tenancyEndDate
    bookingExternalId
    propertyId
    originId
    customFieldValues {
      id
      labelName
      value
    }
  }
`;

const FRAGMENT_GLOBAL_SEARCH_PAYMENT_ITEM = gql`
  fragment FragmentGlobalSearchPaymentItem on GlobalSearchPaymentItem {
    category
    name
    totalAmount
    status
    receiptNumber
    bookingId
    description
    propertyId
    currency
  }
`;

const FRAGMENT_GLOBAL_SEARCH_TRANSACTION_RECORDS = gql`
  fragment FragmentGlobalSearchTransactionRecord on GlobalSearchTransactionRecord {
    transactionId
    transactionDateTime
    type
    description
    amount
    referenceInfo
    bookingId
    category
    name
    channel
    method
    propertyId
    originId
  }
`;

const FRAGMENT_GLOBAL_SEARCH_NOMINATION_PLANS = gql`
  fragment FragmentGlobalSearchNominationPlan on GlobalSearchNominationPlan {
    endDate
    nominationPlanId
    originId
    propertyName
    startDate
    academicYearName
    name
    academicYearId
    propertyId
  }
`;

export const QUERY_GET_GLOBAL_SEARCH_BOOKING_AND_STUDENT = gql`
  query GetGlobalSearchBookingAndStudent($searchValue: NonEmptyString!) {
    getGlobalSearchBookingAndStudent(searchValue: $searchValue) {
      bookings {
        ...FragmentGlobalSearchBooking
      }
      emergencyContacts {
        ...FragmentGlobalSearchContact
      }
      guarantors {
        ...FragmentGlobalSearchContact
      }
      students {
        ...FragmentGlobalSearchStudent
      }
    }
  }
  ${FRAGMENT_GLOBAL_SEARCH_BOOKING}
  ${FRAGMENT_GLOBAL_SEARCH_CONTACT}
  ${FRAGMENT_GLOBAL_SEARCH_STUDENT}
`;

export const QUERY_GET_GLOBAL_SEARCH_BILLING = gql`
  query GetGlobalSearchBilling($searchValue: NonEmptyString!) {
    getGlobalSearchBilling(searchValue: $searchValue) {
      paymentItems {
        ...FragmentGlobalSearchPaymentItem
      }
      transactionRecords {
        ...FragmentGlobalSearchTransactionRecord
      }
    }
  }
  ${FRAGMENT_GLOBAL_SEARCH_PAYMENT_ITEM}
  ${FRAGMENT_GLOBAL_SEARCH_TRANSACTION_RECORDS}
`;

export const QUERY_GET_GLOBAL_SEARCH_NOMINATION_PLAN = gql`
  query GetGlobalSearchNominationPlan($searchValue: NonEmptyString!) {
    getGlobalSearchNominationPlan(searchValue: $searchValue) {
      nominationPlans {
        ...FragmentGlobalSearchNominationPlan
      }
    }
  }
  ${FRAGMENT_GLOBAL_SEARCH_NOMINATION_PLANS}
`;
